export default "https://assets.egbcdn.net/assets/packs/_/images/app/app-en-f3ea697dd4ff4c449fc8b08c1360abf4.png";